
import wixWindow from 'wix-window';
import wixLocation from 'wix-location';


export function button4_click(event) {
		if ($w('#firstName').value === 'dyhwit') {
			wixLocation.to('https://www.questair.co.il/mulimain');
			}
		else if ($w('#firstName').value === 'Dyhwit') {
			wixLocation.to('https://www.questair.co.il/mulimain');
			}
		else if ($w('#firstName').value === 'DYHWIT') {
			wixLocation.to('https://www.questair.co.il/mulimain');
			}
		else if ($w('#firstName').value === 'dyhwit ') {
			wixLocation.to('https://www.questair.co.il/mulimain');
			}
		else {
		wixWindow.openLightbox("try");
	}
	//Add your code for this event here: 
}